import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAngleLeft,
  faAngleRight,
  faArrowLeft,
  faBan,
  faCoins,
  faBell,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronUp,
  faDownload,
  faEllipsisV,
  faExclamationCircle,
  faExclamationTriangle,
  faFileDownload,
  faInfoCircle,
  faMinus,
  faPen,
  faPencilAlt,
  faPlus,
  faSave,
  faArrowCircleRight,
  faBus,
  faUtensils,
  faBabyCarriage,
  faBookReader,
  faUserMd,
  faSearch,
  faTimes,
  faTrash,
  faHome,
  faSeedling,
  faUserFriends,
  faCog,
  faListAlt,
  faFileAlt,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";

export default function registerFaIcons(): void {
  library.add(
    faCoins,
    faBell,
    faDownload,
    faFileDownload,
    faInfoCircle,
    faTrash,
    faPen,
    faPencilAlt,
    faBan,
    faCheckCircle,
    faExclamationTriangle,
    faEllipsisV,
    faExclamationCircle,
    faSave,
    faTimes,
    faCheck,
    faPlus,
    faAngleLeft,
    faAngleRight,
    faChevronDown,
    faChevronUp,
    faSearch,
    faMinus,
    faArrowLeft,
    faArrowCircleRight,
    faBus,
    faUtensils,
    faBabyCarriage,
    faBookReader,
    faUserMd,
    faHome,
    faSeedling,
    faUserFriends,
    faCog,
    faListAlt,
    faFileAlt,
    faSignOutAlt
  );
}
